<template>
  <div class="lottery-popup">
    <div
      :id="`${id}-wrap`"
      class="lottery-choice-wrap"
      :title="`${buttonLabel}`">
      <input
        v-if="formInputName"
        type="hidden"
        :name="formInputName"
        v-model="internalValue" />
      <label
        v-if="label"
        :id="`${id}-label`"
        class="fillin-label"
        :for="`${id}-button`"
        >{{ label }}</label
      >
      <button
        :id="`${id}-button`"
        ref="choiceButton"
        type="button"
        :class="{
          button: true,
          primary: internalValue,
          secondary: !internalValue
        }"
        :disabled="processing"
        @click.prevent="onOpenPopup()">
        {{ buttonLabel }}
      </button>
    </div>
    <dialog-component
      v-if="show"
      id="lotterychoice-dialog"
      title=""
      :selector="`#${id}-wrap`"
      :hasButtonPane="false"
      @close="onClosePopup()">
      <div
        :id="`${id}-dialog-box`"
        class="dialog-box">
        <div
          :id="`${id}-dialog-box-content`"
          class="content twocolumn-layout">
          <div
            :id="`${id}-filter-wrapper`"
            ref="filters"
            class="group twocolumn-layout__left filter-group collapse hidden">
            <h2 class="header group__header">
              <button
                class="collapse-icon valid"
                type="button">
                <span class="ui-icon ui-icon-triangle-1-s"
                  >Hide/Show Group Contents</span
                >
              </button>
              <span class="header__text">Search Filters </span>
            </h2>
            <div class="rect group__inner">
              <div class="newline search-criteria newline-combobox">
                <label
                  :id="`${id}-location-filter_label`"
                  :for="`${id}-location-filter_label`"
                  class="fillin-label"
                  >Location</label
                >
                <combobox-component
                  :id="`${id}-location-filter`"
                  displayStyle="list"
                  :multiple="true"
                  emptyLabel="All locations"
                  :items="filters.location.options"
                  v-model="filters.location.values"></combobox-component>
              </div>
              <div class="newline search-criteria newline-combobox">
                <label
                  :id="`${id}-keyword-option-filter_label`"
                  :for="`${id}-keyword-option-filter_label`"
                  class="fillin-label"
                  >Keyword Option</label
                >
                <combobox-component
                  :id="`${id}-keyword-option-filter`"
                  displayStyle="list"
                  :items="filters.keywordOption.options"
                  v-model="filters.keywordOption.values"></combobox-component>
              </div>
              <div class="newline search-criteria newline-fillin">
                <label
                  :id="`${id}-keyword-search-filter_label`"
                  :for="`${id}-keyword-search-filter_input`"
                  class="fillin-label"
                  >Keyword Search</label
                >
                <fillin-component
                  :id="`${id}-keyword-search-filter`"
                  v-model="filters.keywordSearch"
                  autocompleteAttribute="off"
                  type="text"></fillin-component>
              </div>
              <button
                class="button primary filter-group-search"
                :id="`${id}-keyword-search-button`"
                @click.prevent="onSearch($event)">
                Search
              </button>
            </div>
          </div>
          <div
            v-if="!hasActivities"
            class="messageContainer container twocolumn-layout__right">
            <div class="messageWrap">
              <span>There are no lottery enrollments available.</span>
            </div>
          </div>
          <div
            v-if="hasActivities"
            class="sectionContainer container twocolumn-layout__right">
            <div
              v-for="(activity, index) in groupedActivities"
              :key="index"
              class="result-content tablecollapsecontainer">
              <div
                tabindex="0"
                role="button"
                class="header result-header tablecollapseheader"
                :aria-expanded="activity.showContent"
                @click.prevent="activity.showContent = !activity.showContent"
                @keyup.enter.prevent="
                  activity.showContent = !activity.showContent
                "
                @keyup.space.prevent="
                  activity.showContent = !activity.showContent
                ">
                <div class="result-header__info">
                  <h2>
                    <span>{{ activity.header }}</span> - <em>{{ index }}</em>
                  </h2>
                  <div class="result-header__count">
                    Sections {{ activity.sections.length }}
                  </div>
                </div>
              </div>
              <table
                v-if="activity.showContent"
                class="table"
                :id="`${id}-table`">
                <caption class="sr-only">
                  Sections for
                  {{
                    activity.header
                  }}
                </caption>
                <thead>
                  <tr>
                    <th style="min-width: 32px">
                      <span style="display: none">Column #1</span>
                    </th>
                    <th>Activity #</th>
                    <th>Description</th>
                    <th>Dates</th>
                    <th>Times</th>
                    <th>Days</th>
                    <th>Location</th>
                    <th>Ages</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="section in activity.sections"
                    :key="section.id">
                    <td
                      class="button-cell button-cell--cart"
                      data-title="">
                      <button
                        :id="`${id}-` + section.id"
                        @click.prevent="onSectionSelect($event, section)"
                        :disabled="processing"
                        class="button secondary">
                        Select
                      </button>
                    </td>
                    <td
                      class="label-cell"
                      data-title="Activity #">
                      {{ section.activityId }}-{{ section.sectionCode }}
                    </td>
                    <td
                      class="label-cell"
                      data-title="Description">
                      {{ section.sectionName }}
                    </td>
                    <td
                      class="label-cell"
                      data-title="Dates">
                      {{ section.dates }}
                    </td>
                    <td
                      class="label-cell"
                      data-title="Times">
                      {{ section.times }}
                    </td>
                    <td
                      class="label-cell"
                      data-title="days">
                      {{ section.days }}
                    </td>
                    <td
                      class="label-cell"
                      data-title="Location">
                      {{ section.locationDescription }}
                    </td>
                    <td
                      class="label-cell"
                      data-title="Ages">
                      {{ section.agesDescription }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
export default {
  name: 'LotteryChoiceComponent',
  emits: ['update:modelValue'],
  props: {
    id: String,
    name: String,
    label: String,
    modelValue: [String, Number],
    personId: Number,
    initialFilters: Array,
    lotterygroup: String,
    allActivities: Array,
    openPopUp: Boolean,
    formInputName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showTableContent: false,
      groupedActivities: {},
      filteredActivities: [],
      hasActivities: false,
      internalValue: '',
      buttonLabel: '- Click to make a selection -',
      show: false,
      processing: false,
      filters: {
        location: {
          options: [],
          values: []
        },
        keywordOption: {
          options: [
            { label: 'Match One', value: 'Match One' },
            { label: 'Match All', value: 'Match All' }
          ],
          values: ['Match One']
        },
        keywordSearch: ''
      }
    }
  },
  created() {
    var selected = this.modelValue
    this.internalValue = selected
    this.checkRules()
    this.filters.location.options = this.filteredActivities
      .reduce((location, section) => {
        if (
          !location.some(
            (locationValue) => locationValue.value === section.locationCode
          )
        ) {
          location.push({
            label: section.locationDescription,
            value: section.locationCode
          })
        }
        return location
      }, [])
      .sort((locationA, locationB) => {
        if (locationA.label.toUpperCase() > locationB.label.toUpperCase())
          return 1
        else return -1
      })

    this.groupActivities()
    this.show = this.openPopUp
  },
  methods: {
    groupActivities() {
      var locationFilters = this.filters.location.values
      var keywordOption = this.filters.keywordOption.values[0]
      var keywordSearch = this.filters.keywordSearch
        .replace(/[&|()*]/g, '')
        .replace(',', ' ')
        .replace('  ', ' ')
        .toLowerCase()
        .split(' ')
      this.hasActivities = false
      this.groupedActivities = this.filteredActivities.reduce(
        (activity, section) => {
          var location = section.locationCode
          var sectionKeywords = section.keywords.toLowerCase().split(',')
          var skipSection = false
          if (locationFilters.length !== 0) {
            if (
              !locationFilters.find(
                (locationValue) => locationValue === location
              )
            )
              return activity
          }
          if (keywordSearch[0]) {
            if (keywordOption === 'Match One') {
              skipSection = true
              keywordSearch.forEach((keywordSearch) => {
                if (sectionKeywords.find((value) => value === keywordSearch))
                  skipSection = false
              })
            }
            if (keywordOption === 'Match All') {
              keywordSearch.forEach((keywordSearch) => {
                if (!sectionKeywords.find((value) => value === keywordSearch))
                  skipSection = true
              })
            }
          }
          if (!skipSection) {
            if (!activity[section.activityId]) {
              activity[section.activityId] = {
                id: section.activityId,
                header: section.activityDescription,
                showContent: false,
                sections: []
              }
            }
            activity[section.activityId].sections.push(section)
            this.hasActivities = true
          }
          return activity
        },
        {}
      )
      Object.keys(this.groupedActivities).forEach((activity) => {
        this.groupedActivities[activity].sections = this.groupedActivities[
          activity
        ].sections.sort((sectionA, sectionB) => {
          if (
            sectionA.sectionName.toUpperCase() >
            sectionB.sectionName.toUpperCase()
          )
            return 1
          else return -1
        })
      })
    },
    checkRules() {
      var initialFilters = this.initialFilters
      this.filteredActivities = this.allActivities.reduce(
        (filteredSections, section) => {
          var skipSection = false
          initialFilters.forEach((filter) => {
            if (section[filter.name] !== '' && filter.value) {
              var filterValue = filter.value.toString()
              if (
                !section[filter.name]
                  .split(',')
                  .find((value) => value === filterValue)
              ) {
                skipSection = true
                if (section.id === this.value) this.internalValue = ''
              }
            }
          })
          if (!skipSection) {
            filteredSections.push(section)
          }
          return filteredSections
        },
        []
      )
    },
    onSearch() {
      if (!this.filters.location.values.length !== 0) {
        this.groupActivities()
        this.$refs.filters.classList.add('hidden')
      }
    },
    onOpenPopup() {
      this.show = true
    },
    onClosePopup() {
      this.show = false
      this.$nextTick(() => {
        this.$refs.choiceButton.focus()
      })
    },
    onSectionSelect(event, section) {
      this.internalValue = section.id
      this.onClosePopup()
    }
  },
  watch: {
    modelValue() {
      if (this.modelValue !== this.internalValue) {
        this.internalValue = this.modelValue
      }
    },
    internalValue() {
      if (this.internalValue) {
        var id = this.internalValue
        this.buttonLabel = this.allActivities.find(
          (activity) => activity.id === id
        ).sectionName
      } else {
        this.buttonLabel = '- Please make a selection -'
      }
      this.$emit('update:modelValue', this.internalValue)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/abstract/mixins.less';
@import '../assets/css/abstract/variables.less';

.lottery-choice-wrap {
  display: flex;
  flex-direction: column;

  button:not(.collapse-icon) {
    margin: 10px 15px;
    width: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  label {
    margin: 4px 15px -8px;
  }
}

@media (max-width: 1150px) {
  .button.primary.filter-group-search {
    width: 100%;
  }
}

@media (max-width: 990px) {
  .lottery-choice-wrap {
    button {
      height: fit-content;
      white-space: wrap;
    }
  }
}
</style>
